module.exports = __webpack_public_path__ + "static/media/powerplate.af670315.png";